import { MailTemplate, MailTemplateType } from "../types/mailTemplate";
import { get, post } from "./fetch.core";
import { Translation } from "./translation.core";

async function loadMailTemplates() {
  const res = await get<MailTemplate[]>("/admin/mailTemplate/list");
  return res.data;
}

async function getMailTemplate(mailTemplateId: string) {
  const res = await get<MailTemplate>(`/admin/mailTemplate/get?templateId=${mailTemplateId}`);
  return res.data;
}

async function createMailTemplate(data: any) {
  await post(`/admin/mailTemplate/create`, data);
}

async function updateMailTemplate(mailTemplateId: string, data: any) {
  await post(`/admin/mailTemplate/update?templateId=${mailTemplateId}`, data);
}

async function testMailTemplate(mailTemplateId: string, email: string, orderId?: string, trackingId?: string) {
  const body: { recipientEmail: string; orderId?: string; trackingId?: string } = { recipientEmail: email };
  if (orderId) body.orderId = orderId;
  if (trackingId) body.trackingId = trackingId;
  const res = await post<{ message: string }>(`/admin/mailTemplate/test?templateId=${mailTemplateId}`, body);
  return res.data;
}

async function loadDeliveriesForTest() {
  const res = await get<{ trackingId: string; orderId: string; shipDate: string; orderNumber?: string }[]>(
    "/admin/mailTemplate/listDeliveriesForTest"
  );
  return res.data;
}

function getMailTemplateTypeTitle(mailTemplateType: MailTemplateType, { t, msg }: Translation) {
  switch (mailTemplateType) {
    case "cartReminder":
      return t(msg.mailTemplate.cartReminder);
    case "orderCreated":
      return t(msg.mailTemplate.orderCreated);
    case "orderConfirmed":
      return t(msg.mailTemplate.orderConfirmed);
    case "orderCancelled":
      return t(msg.mailTemplate.orderCancelled);
    case "orderAutoCancelled":
      return t(msg.mailTemplate.orderAutoCancelled);
    case "orderShipped":
      return t(msg.mailTemplate.orderShipped);
    case "orderDelivered":
      return t(msg.mailTemplate.orderDelivered);
    case "deliveryLogisticDelivered":
      return t(msg.mailTemplate.deliveryLogisticDelivered);
    case "pickupCompleted":
      return t(msg.mailTemplate.pickupCompleted);
    case "deliveryPreparing":
      return t(msg.mailTemplate.deliveryPreparing);
    case "deliveryCanPickup":
      return t(msg.mailTemplate.deliveryCanPickup);
    case "paymentRefunded":
      return t(msg.mailTemplate.paymentRefunded);
    case "passwordReset":
      return t(msg.mailTemplate.passwordReset);
    case "inStockNotificationAdmin":
      return t(msg.mailTemplate.instockNotification);
    case "emailVerification":
      return t(msg.mailTemplate.emailVerification);
    case "orderConfirmedAdmin":
      return t(msg.mailTemplate.orderConfirmedAdmin);
    case "orderCancelledAdmin":
      return t(msg.mailTemplate.orderCancelledAdmin);
    case "formSubmittedAdmin":
      return t(msg.mailTemplate.formSubmission);
    default:
      return "";
  }
}

const obj = {
  loadMailTemplates,
  getMailTemplate,
  updateMailTemplate,
  testMailTemplate,
  createMailTemplate,
  getMailTemplateTypeTitle,
  loadDeliveriesForTest,
};

export default obj;
